import styled from 'styled-components'
import { Trigger } from '@radix-ui/react-dropdown-menu'

export const DropdownTrigger = styled(Trigger)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  line-height: 1;

  svg {
    color: ${({ theme }) => theme.colors.white0};
  }
`
